// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","icon":"Footer_icon__ctCoM"};